import { query } from 'utils/graphql';

// Actions
const LOAD = 'voyager/certificates/LOAD';
const LOAD_SUCCESS = 'voyager/certificates/LOAD_SUCCESS';
const LOAD_FAIL = 'voyager/certificates/LOAD_FAIL';
const UPLOAD = 'voyager/certificates/UPLOAD';
const UPLOAD_SUCCESS = 'voyager/certificates/UPLOAD_SUCCESS';
const UPLOAD_FAIL = 'voyager/certificates/UPLOAD_FAIL';
const DELETE = 'voyager/certificates/DELETE';
const DELETE_SUCCESS = 'voyager/certificates/DELETE_SUCCESS';
const DELETE_FAIL = 'voyager/certificates/DELETE_FAIL';
const UPDATE_CERT = 'voyager/certificates/UPDATE_KEY';
const UPDATE_CERT_SUCCESS = 'voyager/certificates/UPDATE_KEY_SUCCESS';
const UPDATE_CERT_FAIL = 'voyager/certificates/UPDATE_KEY_FAIL';

// Reducer
const initialState = {
  items: null,
  errors: null,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_SUCCESS:
      return {
        ...state,
        items: [...action.data.certificates],
      };
    case UPLOAD:
      return {
        ...state,
        saving: true,
        errors: null,
      };
    case UPLOAD_SUCCESS:
      return {
        ...state,
        saving: false,
        items: [
          ...state.items,
          action.data.certificate,
        ],
      };
    case UPLOAD_FAIL:
    case DELETE_FAIL:
      return {
        ...state,
        saving: false,
        errors: action.error.map(({ message }) => message),
      };
    case DELETE:
      return {
        ...state,
        errors: null,
      };
    case DELETE_SUCCESS:
      return {
        ...state,
        errors: null,
        items: state.items.filter(({ fingerprint }) => fingerprint !== action.fingerprint),
      };
    case UPDATE_CERT:
      return {
        ...state,
        saving: true,
        errors: null,
      };
    case UPDATE_CERT_SUCCESS:
      return {
        ...state,
        saving: false,
        items: [
          ...state.items.filter(item => item.fingerprint !== action.data.updateCertificate.fingerprint),
          action.data.updateCertificate,
        ],
      };
    case UPDATE_CERT_FAIL:
      return {
        ...state,
        saving: false,
        errors: action.error.map(({ message }) => message),
      };
    default:
      return state;
  }
}

// Action Creators
export function load() {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: query`
      {
        certificates {
          fingerprint
          domains
          validFrom
          validTo
          isSynced
        }
      }
    `,
  };
}

export function upload(certificate, key) {
  return {
    types: [UPLOAD, UPLOAD_SUCCESS, UPLOAD_FAIL],
    force: true,
    promise: query`
      mutation UploadCertificate(
        ${{ certificate }}: String!,
        ${{ key }}: String!
      ) {
        certificate: uploadCertificate(certificate: $certificate, key: $key) {
          fingerprint
          domains
          validFrom
          validTo
          isSynced
        }
      }
    `,
  };
}

export function remove(fingerprint) {
  return {
    types: [DELETE, DELETE_SUCCESS, DELETE_FAIL],
    force: true,
    fingerprint,
    promise: query`
      mutation DeleteCertificate(
        ${{ fingerprint }}: String!
      ) {
        deleteCertificate(fingerprint: $fingerprint)
      }
    `,
  };
}

export function updateCertificate(fingerprint, certificate) {
  return {
    types: [UPDATE_CERT, UPDATE_CERT_SUCCESS, UPDATE_CERT_FAIL],
    force: true,
    promise: query`
      mutation UpdateCertificate(
        ${{ fingerprint }}: String!,
        ${{ certificate }}: String!
      ) {
        updateCertificate(fingerprint: $fingerprint, certificate: $certificate) {
          fingerprint
          domains
          validFrom
          validTo
          isSynced
        }
      }
    `,
  };
}
